import { useLocation } from 'react-router-dom'
import { Routes } from '~constants/routes'
import { previousPage } from '~components/App/usePreviousPage'

const tabs = [Routes.wallet, Routes.market, Routes.history, Routes.swap, Routes.staking, Routes.cards]

const getShouldTabBeEnlighten = (route: Routes, currentRoute: string) => {
    if (currentRoute === `/${Routes.buy}`) {
        return `/${route}` === previousPage
    }

    return false
}

function useSelectedTabs() {
    const { pathname } = useLocation()

    return tabs.reduce((tabsObject, tab) => {
        tabsObject[tab] = getShouldTabBeEnlighten(tab, pathname)
        return tabsObject
    }, {} as Record<Routes, boolean>)
}

export default useSelectedTabs
